/**
 * 判断是否为开发环境
 */
export function isDev() {
    return process.env.NODE_ENV === 'development'
    // return false
}
